<template>
  <v-layout row wrap justify-center ma-3>
      <v-flex sm11 xs11 md12 lg12>
          <v-data-table :headers="headers" no-results-text="Nenhum registro encontrado" :items-per-page="5"
              :must-sort="true" :items="values" color="secondary" loading-text="Carregando registros...aguarde"
              :sort-by="['diaAlojamento']" :sort-desc="[true]">
              <template v-slot:item.diaAlojamento="{ item }">
                <span :style="getColorDiaAlojamento(item.diaAlojamento)">{{ item.diaAlojamento }}</span>
              </template>
              <template v-slot:item.consumo="{ item }">
                <span :style="getColorDiaAlojamento(item.diaAlojamento)">{{ item.consumo }}</span>
              </template>
              <template v-slot:item.ca="{ item }">
                <span :style="getColorDiaAlojamento(item.diaAlojamento)">{{ item.ca }}</span>
              </template>
              <template v-slot:item.gpd="{ item }">
                <span :style="getColorDiaAlojamento(item.diaAlojamento)">{{ item.gpd }}</span>
              </template>
              <template v-slot:item.ganhoPeso="{ item }">
                <span :style="getColorDiaAlojamento(item.diaAlojamento)">{{ item.ganhoPeso }}</span>
              </template>
              <template v-slot:item.pesoTotal="{ item }">
                <span :style="getColorDiaAlojamento(item.diaAlojamento)">{{ item.pesoTotal }}</span>
              </template>
          </v-data-table>
          <h5 style="color: #ff5429; margin-left: 10px;" v-if="exibeText"> * Valores projetados para o dia atual </h5>
      </v-flex>
  </v-layout>
</template>

<script>

export default {
  components: {
        
    },
  data() {
		return {
            headers: [
                { text: "Dias alojados", value: "diaAlojamento"  },
                { text: "Consumo", value: "consumo" },
                { text: "Conversão", value: "ca" },
                { text: "GPD", value:"gpd" },
                { text: "GP", value:"ganhoPeso" },
                { text: "Peso", value: "pesoTotal" },
            ],
        }
  },
  props:{
      values: Array,
      diasLote: {
        type: Number,
        default: 0
      },
      exibeText: {
        type: Boolean,
        default: false
      }
  },
  methods: {
    getColorDiaAlojamento (diaAlojamento) {
      if (diaAlojamento == this.diasLote && this.exibeText) { 
        return {'color': '#ff5429' }
      }
    },
  },
  computed: {
    
  },
  mounted() {
  },
  watch:{
	},
}
</script>

<style>
  .marginTabel {
    margin-left: 1%; 
    margin-right: 1%;
  }
</style>
